import { APIError } from '../core/errors';
import { getAccessToken } from '../core/localstorage-data';
import httpClient from '../services/http.service';
import { BASE_URL, DEFAULT_HEADERS } from './api-constants';

const _api_base_url = `${BASE_URL}/lmr`;

interface yellowMessengerOutput {
  from: string;
  to: string;
  message: {
    code: string;
    data: {
      number: string;
      name: string;
      param_1: string;
      param_2: string;
      param_3: string;
      param_4: string;
      param_5: string;
      param_6: string;
      param_7: string;
      param_8: string;
      param_9: string;
      param_10: string;
      tags: [string, string, string];
    };
  };
}

interface ReqPayload {
  mobile: string,
}

interface StatusPayload {
  searchColumn: string,
  searchValue: string | null
}

const getAuthHeaders = () => ({
  ...DEFAULT_HEADERS,
  Authorization: `Bearer ${getAccessToken()}`,
});

export const whatsappOptIn = async (payload: ReqPayload
): Promise<yellowMessengerOutput> => {
  const reqPayload = {
    phone_number: payload.mobile,
  };

  try {
    const response = await httpClient.post(`${_api_base_url}/wap-optin`, reqPayload, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const whatsAppStatusCheck = async (payload: StatusPayload): Promise<any> => {
  try {
    const response = await httpClient.post(`${_api_base_url}/wap-optin-check`, payload, {
      headers:
        getAuthHeaders(),
    })
    return response.data;
  } catch (error) {
    throw new APIError(error)
  }
}
